module.exports = __webpack_public_path__ + "img/download-array.7052a34b.svg";